import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/edit.svg'
import _imports_1 from '@/assets/templateIcon.svg'
import _imports_2 from '@/assets/filterIconDisabled.svg'
import _imports_3 from '@/assets/filterIcon.svg'
import _imports_4 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 px-5 tasks-page-fill" }
const _hoisted_2 = { class: "items-center justify-between flex" }
const _hoisted_3 = { class: "cardbody flex relative" }
const _hoisted_4 = {
  ref: "menuContainer",
  class: "flex flex-row-reverse"
}
const _hoisted_5 = {
  key: 0,
  class: "card shadow-sm z-50 absolute cursor-pointer top-9 w-40"
}
const _hoisted_6 = { class: "flex flex-row-reverse items-center" }
const _hoisted_7 = {
  key: 0,
  src: _imports_2,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_3,
  class: "filterIcon"
}
const _hoisted_9 = { class: "tasks-table-section" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_12 = { class: "relative w-full max-w-xl" }
const _hoisted_13 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_14 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_15 = { class: "impactcontainer popupbodycontainer flex-1 overflow-y-auto" }
const _hoisted_16 = { class: "formcontainer flex flex-col h-full" }
const _hoisted_17 = { class: "flex-1 overflow-auto hide-scrollbar pb-5" }
const _hoisted_18 = { class: "formcontainer flex flex-col" }
const _hoisted_19 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_22 = {
  key: 0,
  class: "error-text"
}
const _hoisted_23 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_24 = { class: "w-full" }
const _hoisted_25 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_26 = {
  key: 0,
  class: "error-text"
}
const _hoisted_27 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_28 = { class: "w-1/2" }
const _hoisted_29 = ["min"]
const _hoisted_30 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_31 = {
  key: 0,
  class: "error-text"
}
const _hoisted_32 = { class: "w-1/2 leftspacing" }
const _hoisted_33 = ["min", "disabled"]
const _hoisted_34 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_35 = {
  key: 0,
  class: "error-text"
}
const _hoisted_36 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_37 = { class: "w-6/12" }
const _hoisted_38 = { class: "mt-2" }
const _hoisted_39 = { class: "w-6/12 leftspacing" }
const _hoisted_40 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_41 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_42 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_43 = { class: "mt-2" }
const _hoisted_44 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_45 = {
  key: 0,
  class: "error-text"
}
const _hoisted_46 = { class: "upperspacing gap-4" }
const _hoisted_47 = { class: "w-full" }
const _hoisted_48 = { class: "mt-2" }
const _hoisted_49 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_50 = {
  key: 0,
  class: "error-text"
}
const _hoisted_51 = { class: "w-6/12 mt-3 mb-4" }
const _hoisted_52 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_53 = {
  key: 0,
  class: "error-text"
}
const _hoisted_54 = { class: "buttonposition flex justify-end items-center pt-4" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_58 = { class: "relative w-full max-w-xl" }
const _hoisted_59 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_60 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_61 = { class: "impactcontainer popupbodycontainer flex-1 overflow-y-auto" }
const _hoisted_62 = { class: "formcontainer flex flex-col h-full" }
const _hoisted_63 = { class: "flex-1 overflow-auto hide-scrollbar pb-3" }
const _hoisted_64 = { class: "formcontainer flex flex-col" }
const _hoisted_65 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_66 = { class: "w-full" }
const _hoisted_67 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_68 = {
  key: 0,
  class: "error-text"
}
const _hoisted_69 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_70 = { class: "w-full" }
const _hoisted_71 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_72 = {
  key: 0,
  class: "error-text"
}
const _hoisted_73 = { class: "row flex flex-row w-full upperspacing gap-4" }
const _hoisted_74 = { class: "w-1/2" }
const _hoisted_75 = ["min"]
const _hoisted_76 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_77 = {
  key: 0,
  class: "error-text"
}
const _hoisted_78 = { class: "w-1/2 ml-2" }
const _hoisted_79 = ["min", "disabled"]
const _hoisted_80 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_81 = {
  key: 0,
  class: "error-text"
}
const _hoisted_82 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_83 = { class: "w-full" }
const _hoisted_84 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_85 = {
  key: 0,
  class: "error-text"
}
const _hoisted_86 = { class: "buttonposition flex justify-end items-center pt-4" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "Dummy Tasks")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
            class: _normalizeClass(["btns flex justify-center items-center", _ctx.isAddDisabled ? 'btndisabled pointer-events-none':'btnprimary'])
          }, "Add", 2),
          (_ctx.isMenuVisible)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                _createElementVNode("li", {
                  class: "px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showpopupOnAddForNewTasks()))
                }, [...(_cache[31] || (_cache[31] = [
                  _createElementVNode("div", { class: "flex" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "",
                      class: "mr-2"
                    }),
                    _createTextVNode("New Task")
                  ], -1)
                ]))]),
                _createElementVNode("li", {
                  class: "px-4 py-2 cursor-pointer h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showpopupOnAddForTemplate()))
                }, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("div", { class: "flex" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "",
                      class: "mr-2"
                    }),
                    _createTextVNode(" From Template")
                  ], -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["ml-3 flex", _ctx.tableRow.length == 0 ? 'filterButtonDisable pointer-events-none' : 'filterButton']),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            (_ctx.tableRow.length == 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : (_openBlock(), _createElementBlock("img", _hoisted_8)),
            _cache[33] || (_cache[33] = _createTextVNode(" Filters ", -1))
          ], 2)
        ])
      ])
    ]),
    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "mt-3" }, [
      _createElementVNode("p", { class: "headerText" }, " A Planner is a tool that helps people organize and manage projects. This can include setting goals and objectives, creating schedules and budgets, assigning tasks and resourses, and tracking progress. A Planner is a tool that helps people organize and manage projects. This can include setting goals and objectives, creating schedules and budgets, assigning tasks and resourses, and tracking progress. ")
    ], -1)),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_tableData, {
        class: "flex-1 min-h-0",
        tableRowData: _ctx.tableRow,
        headersData: _ctx.headersTable,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showpopupForTasksfromNew)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.showpopupForTasksfromNew
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.isEdit ? 'Edit Task' : 'New Task'), 1),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCancelButtonForTasks()))
                    }, [...(_cache[35] || (_cache[35] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))])
                  ]),
                  _cache[47] || (_cache[47] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newTasksObject.taskTitle) = $event)),
                                class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.newTasksObject.taskTitle.$error}]),
                                placeholder: "Title Name"
                              }, null, 2), [
                                [
                                  _vModelText,
                                  _ctx.newTasksObject.taskTitle,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.newTasksObject.taskTitle.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    (_ctx.v$.newTasksObject.taskTitle.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.newTasksObject.description.$error}]),
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newTasksObject.description) = $event)),
                                placeholder: "Description"
                              }, null, 2), [
                                [
                                  _vModelText,
                                  _ctx.newTasksObject.description,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.newTasksObject.description.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    (_ctx.v$.newTasksObject.description.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _cache[38] || (_cache[38] = _createElementVNode("label", { class: "controllabel" }, "Start Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newTasksObject.startDate) = $event)),
                              class: _normalizeClass(["mt-2", {'is-invalid': _ctx.v$.newTasksObject.startDate.$error,'inputboxstylingForSelectAtPopup': _ctx.newTasksObject.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.newTasksObject.startDate !== ''}]),
                              onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              min: _ctx.today,
                              onkeydown: "return false",
                              placeholder: "Select Date"
                            }, null, 42, _hoisted_29), [
                              [_vModelText, _ctx.newTasksObject.startDate]
                            ]),
                            (_ctx.v$.newTasksObject.startDate.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  (_ctx.v$.newTasksObject.startDate.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newTasksObject.dueDate) = $event)),
                              class: _normalizeClass(["mt-2", {'is-invalid': _ctx.v$.newTasksObject.dueDate.$error,'inputboxstylingForSelectAtPopup': _ctx.newTasksObject.dueDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.newTasksObject.dueDate !== ''}]),
                              onFocus: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              min: _ctx.newTasksObject.startDate,
                              onkeydown: "return false",
                              disabled: _ctx.newTasksObject.startDate === '' ? true : false,
                              placeholder: "Select Date"
                            }, null, 42, _hoisted_33), [
                              [_vModelText, _ctx.newTasksObject.dueDate]
                            ]),
                            (_ctx.v$.newTasksObject.dueDate.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  (_ctx.v$.newTasksObject.dueDate.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "controllabel" }, "System/Activity", -1)),
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_Select, {
                                modelValue: _ctx.newTasksObject.controlLevel,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newTasksObject.controlLevel) = $event)),
                                options: _ctx.globalOptions,
                                optionLabel: "data",
                                appendTo: "self",
                                optionValue: "id",
                                placeholder: "Please select",
                                class: "inputboxstyling mt-2",
                                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.controlLevelOptions(_ctx.newTasksObject.controlLevel)))
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            (_ctx.newTasksObject.controlLevel==10107)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_40, "Activity"))
                              : _createCommentVNode("", true),
                            (_ctx.newTasksObject.controlLevel==10108)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_41, "System"))
                              : _createCommentVNode("", true),
                            (_ctx.newTasksObject.controlLevel=='')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_42, "System/Activity"))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_43, [
                              (_ctx.newTasksObject.controlLevel!=10107)
                                ? (_openBlock(), _createBlock(_component_AutoComplete, {
                                    key: 0,
                                    modelValue: _ctx.newTasksObject.system,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newTasksObject.system) = $event)),
                                    suggestions: _ctx.systemOptions,
                                    onComplete: _ctx.asyncSystemFind,
                                    onItemSelect: _ctx.selectedOptions,
                                    disabled: _ctx.newTasksObject.controlLevel=='',
                                    optionLabel: "label",
                                    appendTo: "body",
                                    optionValue: "value",
                                    placeholder: "System",
                                    forceSelection: true,
                                    class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
															'p-invalid': _ctx.v$.newTasksObject.system.$error,
															'has-options': _ctx.systemOptions && _ctx.systemOptions.length > 0,
															'no-options': !_ctx.systemOptions.length &&  _ctx.searchValue !== ''   
														}])
                                  }, {
                                    default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                      _createElementVNode("template", { noResult: "" }, [
                                        _createElementVNode("span", null, "No System Found")
                                      ], -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "disabled", "class"]))
                                : _createCommentVNode("", true),
                              (_ctx.newTasksObject.controlLevel==10107)
                                ? (_openBlock(), _createBlock(_component_AutoComplete, {
                                    key: 1,
                                    modelValue: _ctx.newTasksObject.system,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newTasksObject.system) = $event)),
                                    suggestions: _ctx.activityOptions,
                                    onComplete: _ctx.asyncActivityFind,
                                    onItemSelect: _ctx.selectedOptions,
                                    disabled: _ctx.newTasksObject.controlLevel?.value=='',
                                    optionLabel: "label",
                                    optionValue: "value",
                                    appendTo: "body",
                                    forceSelection: true,
                                    placeholder: "Activity",
                                    class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
															'p-invalid':_ctx.v$.newTasksObject.system.$error,
															'has-options': _ctx.activityOptions && _ctx.activityOptions.length > 0,
															'no-options': !_ctx.activityOptions.length &&  _ctx.searchValue !== ''   
														}])
                                  }, null, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "disabled", "class"]))
                                : _createCommentVNode("", true),
                              (_ctx.v$.newTasksObject.system.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    (_ctx.v$.newTasksObject.system.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _cache[43] || (_cache[43] = _createElementVNode("label", { class: "controllabel" }, "Control", -1)),
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.newTasksObject.controlNumber,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newTasksObject.controlNumber) = $event)),
                                suggestions: _ctx.controlOptions,
                                disabled: _ctx.newTasksObject.system=='',
                                onComplete: _ctx.asyncFind2,
                                onItemSelect: _ctx.onControlSelected,
                                optionLabel: "label",
                                optionValue: "value",
                                placeholder: "Control",
                                appendTo: "body",
                                class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
												'p-invalid': _ctx.v$.newTasksObject.controlNumber.$error,
												'has-options': _ctx.controlOptions && _ctx.controlOptions.length > 0,
												'no-options': !_ctx.controlOptions.length &&  _ctx.searchValue !== '',
											}])
                              }, {
                                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                  _createElementVNode("template", { noResult: "" }, [
                                    _createElementVNode("span", null, "No Control Found")
                                  ], -1)
                                ]))]),
                                _: 1
                              }, 8, ["modelValue", "suggestions", "disabled", "onComplete", "onItemSelect", "class"])
                            ]),
                            (_ctx.v$.newTasksObject.controlNumber.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  (_ctx.v$.newTasksObject.controlNumber.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _cache[45] || (_cache[45] = _createElementVNode("label", { class: "controllabel" }, "Assigned To", -1)),
                          _createElementVNode("div", null, [
                            (_openBlock(), _createBlock(_component_AutoComplete, {
                              key: 'assignee-' + _ctx.assigneeFieldKey,
                              modelValue: _ctx.newTasksObject.assignee,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newTasksObject.assignee) = $event)),
                              suggestions: _ctx.userOptions,
                              completeOnFocus: true,
                              onComplete: _ctx.asyncFind,
                              optionLabel: "label",
                              placeholder: "Assigned to",
                              appendTo: "body",
                              class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
													'p-invalid':  _ctx.v$.newTasksObject.assignee.$error,
												'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
												'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== ''
												}])
                            }, {
                              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                _createElementVNode("template", { noResult: "" }, [
                                  _createElementVNode("span", null, "No Members Found")
                                ], -1)
                              ]))]),
                              _: 1
                            }, 8, ["modelValue", "suggestions", "onComplete", "class"])),
                            (_ctx.v$.newTasksObject.assignee.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  (_ctx.v$.newTasksObject.assignee.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[46] || (_cache[46] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.newTasksObject) !== JSON.stringify(_ctx.dummyNewTasksObject) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onCancelbtnForTasks()))
                          }, "Reset", 10, _hoisted_55),
                          (_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateButtonForTasks()))
                              }, "Update"))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                disabled: _ctx.clickOnButton,
                                class: _normalizeClass(JSON.stringify(_ctx.newTasksObject) !== JSON.stringify(_ctx.dummyNewTasksObject) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.submitButtonForNewTasks()))
                              }, "Save", 10, _hoisted_56))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showPopUpForTemplate)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.showPopUpForTemplate
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.isEdit ? 'Edit Tasks For Templates' : 'Tasks For Templates'), 1),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
                    }, [...(_cache[48] || (_cache[48] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))])
                  ]),
                  _cache[56] || (_cache[56] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _cache[50] || (_cache[50] = _createElementVNode("label", { class: "controllabel" }, "Template", -1)),
                              _createElementVNode("div", null, [
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.tasksTemplateObject.template,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tasksTemplateObject.template) = $event)),
                                  suggestions: _ctx.templates,
                                  onComplete: _ctx.asyncFind1,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  appendTo: "self",
                                  placeholder: "Template Name",
                                  class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
												'p-invalid': _ctx.v$.tasksTemplateObject.template.$error,
												'has-options': _ctx.templates && _ctx.templates.length > 0,
												'no-options': !_ctx.templates.length &&  _ctx.searchValue !== ''
											}])
                                }, {
                                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                    _createElementVNode("template", { noResult: "" }, [
                                      _createElementVNode("span", null, "No Templates Found")
                                    ], -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                (_ctx.v$.tasksTemplateObject.template.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                      (_ctx.v$.tasksTemplateObject.template.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _cache[51] || (_cache[51] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.tasksTemplateObject.templateTitle) = $event)),
                                class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.tasksTemplateObject.templateTitle.$error}]),
                                placeholder: "Title Name"
                              }, null, 2), [
                                [
                                  _vModelText,
                                  _ctx.tasksTemplateObject.templateTitle,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.tasksTemplateObject.templateTitle.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                    (_ctx.v$.tasksTemplateObject.templateTitle.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _cache[52] || (_cache[52] = _createElementVNode("label", { class: "controllabel" }, "Start Date", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.tasksTemplateObject.startDate) = $event)),
                                class: _normalizeClass(["mt-2", {'is-invalid': _ctx.v$.tasksTemplateObject.startDate.$error,'inputboxstylingForSelectAtPopup': _ctx.tasksTemplateObject.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.tasksTemplateObject.startDate !== ''}]),
                                min: _ctx.today,
                                onFocus: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                onkeydown: "return false",
                                placeholder: "Select Date"
                              }, null, 42, _hoisted_75), [
                                [_vModelText, _ctx.tasksTemplateObject.startDate]
                              ]),
                              (_ctx.v$.tasksTemplateObject.startDate.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                    (_ctx.v$.tasksTemplateObject.startDate.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _cache[53] || (_cache[53] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.tasksTemplateObject.dueDate) = $event)),
                                class: _normalizeClass(["mt-2", {'is-invalid': _ctx.v$.tasksTemplateObject.dueDate.$error,'inputboxstylingForSelectAtPopup': _ctx.tasksTemplateObject.dueDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.tasksTemplateObject.dueDate !== ''}]),
                                min: _ctx.tasksTemplateObject.startDate,
                                onFocus: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                disabled: _ctx.tasksTemplateObject.startDate === '' ? true : false,
                                onkeydown: "return false",
                                placeholder: "Select Date"
                              }, null, 42, _hoisted_79), [
                                [_vModelText, _ctx.tasksTemplateObject.dueDate]
                              ]),
                              (_ctx.v$.tasksTemplateObject.dueDate.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                    (_ctx.v$.tasksTemplateObject.dueDate.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, [
                              _cache[54] || (_cache[54] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.tasksTemplateObject.description.$error}]),
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.tasksTemplateObject.description) = $event)),
                                placeholder: "Description"
                              }, null, 2), [
                                [
                                  _vModelText,
                                  _ctx.tasksTemplateObject.description,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.tasksTemplateObject.description.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                    (_ctx.v$.tasksTemplateObject.description.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.tasksTemplateObject) !== JSON.stringify(_ctx.dummyTasksTemplateObject) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onCancelbtn()))
                          }, "Reset", 10, _hoisted_87),
                          (_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.updateButtonForTemplate()))
                              }, "Update"))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                disabled: _ctx.clickOnButton,
                                class: _normalizeClass(JSON.stringify(_ctx.tasksTemplateObject) !== JSON.stringify(_ctx.dummyTasksTemplateObject) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.submitButtonforTemplate()))
                              }, "Save", 10, _hoisted_88))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}